import apiBase from './apiBase';

class TerytApi {
  static loadLocalities(terytPrefixFilter) {
    const url = terytPrefixFilter ? `/teryt/localities?terytPrefixFilter=${terytPrefixFilter}` : '/teryt/localities';
    return apiBase.get(url);
  }
  
  static loadStreets(localityCode) {
    return apiBase.get(`/teryt/streets?localityCode=${localityCode}`);
  }
}

export default TerytApi;



// WEBPACK FOOTER //
// ./src/api/terytApi.js